export default {
    googleMapKey: "AIzaSyCutNBjAvKMdqlPw8VFr_u_d7amic0LU40",
    baseURL: "https://vendor.delivitapp.com"
}